import styled, { keyframes } from 'styled-components';
import React, { useEffect, useState } from 'react';
import { Radio, RadioGroup } from 'react-radio-group';
import { colors } from '_styles';
import { connect } from 'react-redux';
import { _ } from '_locales';
import { Button } from '../../Education/components';

const ExtraSelection = ({
  bpData,
  mainColor,
  setCurrentPage,
  currentPage,
  dropdownSelection,
  setDropdownSelection
}) => {
  const {
    extra_dropdown_title,
    extra_dropdown_value
  } = bpData?.bulk_pickup_config;
  const changeHandler = (value) => {
    setDropdownSelection(value);
  };

  const { main_color } = mainColor;
  const RadioButtonContainer = styled.fieldset`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 0;
    border: none;

    & input {
      margin-right: 10px;
      transform: scale(1.5);
      accent-color: ${colors.RC_ACTION};
      cursor: pointer;
    }
    span {
      display: inline-block;
      font-size: 16px;
      font-weight: 400 !important;
      margin: 10px;
    }
  `;

  return (
    <Container>
      <Wrapper>
        <RadioGroup
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            marginLeft: 10,
          }}
          selectedValue={dropdownSelection}
          onChange={changeHandler}
        >
          <RadioButtonContainer>
            <TextHeader>{extra_dropdown_title}</TextHeader>

            {extra_dropdown_value.split(',').map((item) => (
              <label htmlFor={item}>
                <Radio
                  value={item}
                  id={item}
                />
                <span>{item}</span>
              </label>
            ))}

          </RadioButtonContainer>
        </RadioGroup>
        <View
          style={{
            display: 'flex',
            gap: 20,
            marginTop: 20,
            justifyContent: 'flex-end',
          }}
        >
          <Button
            backgroundColor="fff"
            color={main_color || colors.RC_ACTION}
            aria-label={'Back'}
            fontSize="16px"
            padding="12px 24px"
            onClick={() => {
              setCurrentPage(currentPage - 1);
            }}
          >
            {_('bulkPickup.back')}
          </Button>
          <Button
            mainColor={main_color || false}
            aria-label={'Next'}
            onClick={() => setCurrentPage(currentPage + 1)}
            fontSize="16px"
            padding="12px 24px"
            disabled={!dropdownSelection}
          >
            {_('bulkPickup.next')}
          </Button>
        </View>
      </Wrapper>
    </Container>
  );
};

export default connect(
  (state) => ({
    mainColor: state.config.templateColour
      ? JSON.parse(state.config.templateColour)
      : {},
  }),
  null
)(ExtraSelection);

const TextHeader = styled.legend`
  letter-spacing: 1px;
  cursor: pointer;
  margin: 0 0 10px 0 !important;
  font-size: 18px !important;
  color: #000000 !important;
  font-weight: 600 !important;
  font-family: Roboto, sans-serif !important;
  width: 100%;
`;

const Container = styled.div`
  box-sizing: border-box;
  padding: 20px;
  border-radius: 10px;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 18px 0px;
  margin-top: 15px;
  margin-bottom: 35px;
`;

const OpacityAnimation = keyframes`
  from { opacity: 0;}
  to { opacity:1;}
`;

const View = styled.div`
  animation: ${OpacityAnimation} 0.5s;
`;

const Wrapper = styled.div`
  margin: 15px auto;
  max-width: 600px;
`;

const Error = styled.p`
  color: rgb(178, 1, 7);
  margin: 10px 0 0 10px;
  font-size: 13px;
`;
